import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
// import { v4 as uuidv4 } from "uuid";

import { baseUrl, getCurrentDate } from "../../utils";
import axios from "axios";
import Swal from "sweetalert2";
import { updateChildrenInformations } from "../../store/reducer/accountReducer";
import {
  createAccountRequest,
  deleteChildInformation,
} from "../../store/reducer/accountReducer";
import Loader from "../loader";

const ChildInfo = ({ nextComponent, prevComponent }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
  }, []);

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [docSubmit, setDocumentSubmit] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
 

  //  const [bank, setBank] = useState("");
  // const [branch, setBranch] = useState("");

  // const accountState = useSelector((state) => state.account);

  const nationalityCode = "566#Nigeria";
  const dispatch = useDispatch();
  // const showModal = useSelector((state) => state.account.showModal);

  /* END OF MODAL HANDLES */

  // GET CURRENT DATE IN YYYY-MM-DD FORMAT

  const deleteCheck = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteChildInformation(index));
        Swal.fire("Deleted!", "Entry deleted.", "success");
      }
    });
  };

  const [data, setData] = useState({
    title: "",
    nin: "",
    surName: "",
    firstName: "",
    middleName: "",
    religion: "",
    nationality: "",
    phoneNumber: "",
    dateOfBirth: "",
    gender: "",
    stateOfOrigin: "",
    lgaOfBirth: "",
    placeOfBirth: "",
    schoolName: "",
    childClass: "",
    residentialAddress: "",
    residentialLGA: "",
    countryOfResidence: "",
    stateOfResidence: "",
    ageBracket: "",
    city: "",
    province: "",
    braCode: "",
    mothersMaidenName: "",
    productType: "",
    introducerCode: "",
    accountServices: {
      debitCard: false,
    },
    documents: [],
  });

  const { loading } = useSelector((state) => state.account);
  const childrenInformations = useSelector(
    (state) => state.account.createAccount.childrenInformations
  );

  //  EDIT DATA

  const checkAgeRange = data.ageBracket;

  const [childrenData, setChildrenData] = useState(childrenInformations);
  const [isLoading, setIsLoading] = useState(false);

  /* START OF NEXT AND PREVIOUS HANDLES */
  const handleNextClick = () => {
    nextComponent();
  };

  const handlePrevClick = () => {
    prevComponent();
  };

  /* START OF NEXT AND PREVIOUS HANDLES */

  /* START OF DOCUMENT VIEW HANDLES */
  const handleViewDocument = (base64String) => {
    const pdfWindow = window.open("");
    pdfWindow.document.write(
      `<iframe width='100%' height='100%' src='${base64String}'></iframe>`
    );
  };
  /* START OF NEXT AND PREVIOUS HANDLES */

  /* START OF INPUT CHANGE HANDLE */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setData((prevData) => ({
        ...prevData,
        accountServices: {
          ...prevData.accountServices,
          [name]: checked,
        },
      }));
    } else if (name === "phoneNumber" || name === "nin") {
      const regex = /^[0-9]*$/; // Only allow numbers
      if (!regex.test(value)) {
        return;
      } else {
        setData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {
      setData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  /* END OF INPUT CHANGE HANDLE */

  /* START OF ADD DOCUMENTS HANDLE */

  const handleAddDocument = (e) => {
    e.preventDefault();
    if (!selectedFile) {
      setErrorMessage("Please upload a document");
      return;
    }
    if (!selectedOption) {
      setErrorMessage("Please select an option");
      return;
    }
    setDocumentSubmit(true);

    const { value } = document.getElementById("document-type");
    const fileInput = document.getElementById("document-file");
    const errorMessageElement = document.getElementById("error-message");

    if (fileInput.files.length > 0) {
      const file = fileInput.files[0];
      const fileType = file.type;
      const fileSize = file.size / 1024; // Convert to KB
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
      ];
      const allowedSize = 500; // KB

      if (allowedTypes.includes(fileType)) {
        if (fileSize <= allowedSize) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            const base64String = reader.result;
            setData((prevData) => ({
              ...prevData,
              documents: [
                ...prevData.documents,
                {
                  documentType: value,
                  name: file.name,
                  dateIssued: moment(new Date()).format("YYYY-MM-DD"),
                  dateExpired: moment(new Date()).format("YYYY-MM-DD"),
                  file: base64String,
                },
              ],
            }));

            setSelectedFile(null);
            setSelectedOption("");
            setErrorMessage("");

            document.getElementById("document-type").selectedIndex = 0; // reset the select element
            document.getElementById("document-file").value = "";
            errorMessageElement.textContent = "";
          };
        } else {
          setErrorMessage("Please upload a file not more than 500KB.");
        }
      } else {
        setErrorMessage("Please upload a file of type jpg, jpeg,png or pdf");
      }
    }

    setSelectedFile(null);
    setSelectedOption("");
    // setErrorMessage('');
  };

  const handleDeleteDocument = (index) => {
    setData((prevData) => {
      const updatedDocuments = [...prevData.documents];
      updatedDocuments.splice(index - 1, 1); // Remove the document at the given index
      return {
        ...prevData,
        documents: updatedDocuments,
      };
    });
  };

  const deleteDoc = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Call handleDeleteDocument passing the index
        handleDeleteDocument(index);

        Swal.fire("Deleted!", "Your file has been deleted.", "success");
      }
    });
  };

  /* END OF ADD DOCUMENTS HANDLE */

  /* START OF SUBMIT HANDLE */
  const [selectedIndex] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!docSubmit) {
      setErrorMessage("Please upload a document");
      return;
    } else {
      setDocumentSubmit(false);
    }

    setIsLoading(true);

    // const accountState = useSelector(state => state.account); // Access the account state from the store

    if (isEditMode) {
      // Update existing row in tableData
      const updatedChildrenInformations = childrenInformations.map(
        (childInfo) => {
          if (childInfo.id === data.id) {
            return { ...data };
          } else {
            return childInfo;
          }
        }
      );
      dispatch(deleteChildInformation(objDeleted));
      // Dispatch the action to update the childrenInformations in the store
      dispatch(
        updateChildrenInformations({
          index: selectedIndex,
          updatedData: updatedChildrenInformations,
        })
      );
      setIsEditMode(false);
    } else {
      // Add new row to tableData
      const newData = { ...data }; // Assign a unique ID using uuidv4
      setTableData((prevData) => [...prevData, newData]);
    }

    // Dispatch the action to send data to the store

    if(data.ageBracket ==="")
    {
     let ageBracket = "0-12"

    data.ageBracket = ageBracket
      dispatch(createAccountRequest(data));
      
    }else{
      dispatch(createAccountRequest(data));

    }

    // Clear the form data and reset Edit mode
    setData({
      title: "",
      nin: "",
      surName: "",
      firstName: "",
      middleName: "",
      religion: "",
      nationality: "",
      phoneNumber: "",
      dateOfBirth: "",
      gender: "",
      stateOfOrigin: "",
      lgaOfBirth: "",
      placeOfBirth: "",
      schoolName: "",
      childClass: "",
      residentialAddress: "",
      residentialLGA: "",
      countryOfResidence: "",
      stateOfResidence: "",
      ageBracket: "",
      city: "",
      province: "",
      braCode: "",
      mothersMaidenName: "",
      productType: "",
      introducerCode: "",
      accountServices: {
        debitCard: false,
      },
      documents: [],
    });

    setIsEditMode(false);
    setErrorMessage("");
  };
  const [objDeleted] = useState("");

  /* START OF SUBMIT HANDLE */
  useEffect(() => {
    setChildrenData(childrenData);
    if (!loading && isLoading) {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  }, [loading, isLoading, childrenData]);

  const gender =[
    {
      id:1,
      text:"Male",
      value:"1"
    },
    {
      id:2,
      text:"Female",
      value:"2"
    }
  ]

  /* UPDATE DOCUMENT TYPE */
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    axios
      .get(
        `${baseUrl}/kidsaccountopeningapi/api/v1/AccountOpening/GetDocumentTypes`
      )
      .then((response) => {
        setDocs(response.data.data);
      })
      .catch((error) => {
        // console.log(error);
      });
  }, []);

  /* UPDATE LGA */

  const [lgas, setLgas] = useState([]);
  useEffect(() => {
    axios
      .get(
        "https://ubanking.suntrustng.com/AccountOpeningV2/api/v1/AccountOpening/GetLocalGovt"
      )
      .then((response) => {
        const sortedLgas = response.data.sort((a, b) =>
          a.text.localeCompare(b.text)
        );
        setLgas(sortedLgas);
      })
      .catch((error) => {
        // console.log(error);
      });
  }, []);

  /* UPDATE STATE */
  const [states, setStates] = useState([]);
  useEffect(() => {
    axios
      .get(
        "https://ubanking.suntrustng.com/AccountOpeningV2/api/v1/AccountOpening/GetState"
      )
      .then((response) => {
        const sortedStates = response.data.sort((a, b) =>
          a.text.localeCompare(b.text)
        );
        setStates(sortedStates);
      })
      .catch((error) => {
        // console.log(error).log(error);
      });
  }, []);

  /* UPDATE CITY */
  const [cities, setCities] = useState([]);
  useEffect(() => {
    axios
      .get(
        "https://ubanking.suntrustng.com/AccountOpeningV2/api/v1/AccountOpening/GetCity"
      )
      .then((response) => {
        const sortedPlacesOfBirth = response.data.sort((a, b) =>
          a.text.localeCompare(b.text)
        );

        setCities(sortedPlacesOfBirth);
      })
      .catch((error) => {
        // console.log(error).log(error);
      });
  }, []);

  /* UPDATE BRANCH */
  const [branches, setBranches] = useState([]);
  useEffect(() => {
    axios
      .get(
        "https://ubanking.suntrustng.com/AccountOpeningV2/api/v1/AccountOpening/GetBranch"
      )
      .then((response) => {
        setBranches(response.data);
      })
      .catch((error) => {
        // console.log(error).log(error);
      });
  }, []);

  // UPDATE PROVINCE
  //

  const [provinces, setProvinces] = useState([]);
  useEffect(() => {
    axios
      .get(
        "https://ubanking.suntrustng.com/AccountOpeningV2/api/v1/AccountOpening/GetCity"
      )
      .then((response) => {
        const sortedProvinces = response.data.sort((a, b) =>
          a.text.localeCompare(b.text)
        );
        setProvinces(sortedProvinces);
      })
      .catch((error) => {
        // console.log(error).log(error);
      });
  }, []);

  // UPDATE PRODUCT TYPE
  const [products, setProducts] = useState([]);
  useEffect(() => {
    axios
      .get(
        `${baseUrl}/kidsaccountopeningapi/api/v1/AccountOpening/GetProductTypes`
      )
      .then((response) => {
        setProducts(response.data.data);
      })
      .catch((error) => {
        // console.log(error).log(error);
      });
  }, []);

  return (
    <div className="page">
      <div className="flex-column">
        <div className="kiddies_hero"></div>

        <div className="kiddies_hero-tablet"></div>

        <div className="kiddies_hero-mobile"></div>

        <div className="col-lg-12  m-b-50 ">
          <section className="step-wizard m-b-30">
            <ul className="step-wizard-list">
              <li className="step-wizard-item m-b-10">
                <span className="progress-count">1</span>
                <span className="progress-title">Introduction</span>
              </li>
              <li className="step-wizard-item current-item">
                <span className="progress-count">2</span>
                <span className="progress-title">Child Information</span>
              </li>
              <li className="step-wizard-item">
                <span className="progress-count">3</span>
                <span className="progress-title">
                  Parent / Guardian Information
                </span>
              </li>
              {/* <li className="step-wizard-item">
              <span className="progress-count">4</span>
              <span className="progress-title">Upload Documents</span>
            </li> */}
              <li className="step-wizard-item">
                <span className="progress-count">4</span>
                <span className="progress-title">Review Information</span>
              </li>
            </ul>
          </section>

          <section className="step-wizard-tablet m-b-30">
            <ul className="step-wizard-list">
              <li className="step-wizard-item m-b-10">
                <span className="progress-count">1</span>
                <span className="progress-title">Introduction</span>
              </li>
              <li className="step-wizard-item current-item">
                <span className="progress-count">2</span>
                <span className="progress-title">Child Information</span>
              </li>
              <li className="step-wizard-item">
                <span className="progress-count">3</span>
                <span className="progress-title">
                  Parent / Guardian Information
                </span>
              </li>

              <li className="step-wizard-item">
                <span className="progress-count">4</span>
                <span className="progress-title">Review Information</span>
              </li>
            </ul>
          </section>

          <div className="tab-content" id="myTabContent">
            <div
              className="fade show active"
              id="account_spec"
              role="tabpanel"
              aria-labelledby="account_spec-tab"
            >
              <form onSubmit={handleSubmit}>
                {/* <!-- PERSONAL DETAILS --> */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-user m-r-5"></i> Personal Information
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where the personal details of the
                        child is entered. Please, provide the correct details.
                      </div>
                    </div>

                    <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                      {/* <!-- <div className="col-lg-12"> --> */}
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>National Identity Number (NIN) </label>
                          <input
                            type="text"
                            className="form-control"
                            name="nin"
                            value={data.nin}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Title <span className="text-danger">*</span>
                          </label>
                          <select
                            name="title"
                            id="mrormrs"
                            className="form-control"
                            value={data.title}
                            onChange={handleChange}
                            required
                          >
                            <option
                             value=""
                             defaultValue="selected"
                             disabled="disabled"
                            >-Select Title-</option>
                            <option value="1#Master">Master</option>
                            <option value="2#Miss">Miss</option>
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Surname <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="surName"
                            required
                            value={data.surName}
                            onChange={handleChange}
                          />
                          {/* <p>{errors.surName?.message}</p> */}
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Firstname <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            required
                            value={data.firstName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>Middlename</label>
                          <input
                            type="text"
                            className="form-control"
                            name="middleName"
                            value={data.middleName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Phone Number <span className="text-danger">*</span>
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            name="phoneNumber"
                            maxLength="11"
                            required
                            value={data.phoneNumber}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Date of Birth <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="dateOfBirth"
                            required
                            value={data.dateOfBirth}
                            onChange={handleChange}
                            max={getCurrentDate()}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>Mothers Maiden Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="mothersMaidenName"
                            value={data.mothersMaidenName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Gender <span className="text-danger">*</span>
                          </label>
                          <select
                            name="gender"
                            id="gender"
                            className="form-control "
                            required
                            value={data.gender}
                            onChange={handleChange}
                          >
                            <option 
                             value=""
                             defaultValue="selected"
                             disabled="disabled"
                            >-Select Gender-</option>
                            {gender.map((gend) => (
                              <option
                                key={gend.id}
                                value={`${gend.value}#${gend.text}`}
                              >
                                {gend.text}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Religion <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="religion"
                            name="religion"
                            required
                            value={data.religion}
                            onChange={handleChange}
                          >
                            <option
                              value=""
                              defaultValue="selected"
                              disabled="disabled"
                            >
                              -- Select One --
                            </option>
                            <option value="1#Muslim">Muslim</option>
                            <option value="2#Christian">Christian</option>
                            <option value="3#Jewish">Jewish</option>
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>
                            State of origin{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="stateOfOrigin"
                            name="stateOfOrigin"
                            required
                            value={data.stateOfOrigin}
                            onChange={handleChange}
                          >
                            <option value="">Select state of origin</option>
                            {states.map((state) => (
                              <option
                                key={state.value}
                                value={`${state.value}#${state.text}`}
                              >
                                {state.text}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            L.G.A <span className="text-danger">*</span>
                          </label>

                          <select
                            className="form-control dropdown"
                            id="lgaOfBirth"
                            name="lgaOfBirth"
                            required
                            value={data.lgaOfBirth}
                            onChange={handleChange}
                          >
                            <option value="">--Select lga--</option>
                            {lgas.map((lga) => (
                              <option
                                key={lga.value}
                                value={`${lga.value}#${lga.text}`}
                              >
                                {lga.text}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>
                            Place of Birth{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="placeOfBirth"
                            name="placeOfBirth"
                            required
                            value={data.placeOfBirth}
                            onChange={handleChange}
                          >
                            <option value="">--Select place of birth--</option>
                            {cities.map((city) => (
                              <option
                                key={city.value}
                                value={`${city.value}#${city.text}`}
                              >
                                {city.text}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Country of Birth{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            name="nationality"
                            id="nationality"
                            className="form-control"
                            required
                            value={data.nationality}
                            onChange={handleChange}
                          >
                            <option
                             value=""
                             defaultValue="selected"
                             disabled="disabled"
                            >-Select Nationality-</option>
                            <option value="1#Nigeria">Nigeria</option>
                          </select>
                        </div>

                        {/* <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>
                            Country of Birth{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            id="country"
                            name="nationality"
                            value={data.nationality}
                            disabled
                            required
                            onChange={handleChange}
                            className="form-control"
                          >
                            <option value={data.nationality}>Nigeria</option>
                          </select>
                        </div> */}
                      </div>

                      <div className="row">
                        <div className="form-group col-lg-12 col-md-12 col-sm-12">
                          <label className="font-weight-500">
                            Please Tick the Child's Age bracket
                            <span className="text-danger">*</span>
                          </label>

                          <div className="form-group">
                            <div className="col-lg-3 col-md-3 col-sm-12">
                              <input
                                type="radio"
                                className=""
                                id="ib1"
                                name="ageBracket"
                                value="0-12"
                                style={{marginRight: "10px"}}
                                required
                                onChange={handleChange}
                                data-parsley-errors-container="#error-checkbox"
                              />
                              <label
                                className=""
                                htmlFor="ib1"
                              >
                                Child (0 - 12yrs)
                              </label>
                            </div>

                            <div className=" custom-checkbox inline-cc col-lg-3 col-md-3 col-sm-12">
                              <input
                                type="radio"
                                className=""
                                id="mm1"
                                name="ageBracket"
                                value="13-17"
                                style={{marginRight: "10px"}}
                                onChange={handleChange}
                              />
                              <label
                                className=""
                                htmlFor="mm1"
                              >
                                Teenager (13 - 17yrs)
                              </label>
                            </div>
                            <p id="error-checkbox"></p>
                          </div>
                        </div>
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                  {/* <!-- </div> --> */}
                </div>

                {/* <!-- SCHOOL INFORMATION --> */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-graduation-cap m-r-5"></i>School
                    Information
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where details of the child's education
                        are entered. Please, provide the correct details.
                      </div>
                    </div>

                    <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                      <div className="row">
                        <div className="form-group col-lg-9 col-md-6 col-sm-12 font-weight-500">
                          <label>Name of Child's School </label>
                          <input
                            type="text"
                            className="form-control"
                            name="schoolName"
                            value={data.schoolName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-3 col-md-6 col-sm-12 font-weight-500">
                          <label>Child's class/grade </label>
                          <input
                            type="text"
                            className="form-control"
                            id="childClass"
                            name="childClass"
                            value={data.childClass}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- </div> --> */}
                </div>

                {/* <!-- ADDRESS DETAILS --> */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-home m-r-5"></i>Address Details
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where the address details of the child
                        are entered. Please, provide the correct details.
                      </div>
                    </div>

                    <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>
                            Residential Address{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="residentialAddress"
                            required
                            value={data.residentialAddress}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Residential L.G.A{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="residentialLGA"
                            name="residentialLGA"
                            required
                            value={data.residentialLGA}
                            onChange={handleChange}
                          >
                            <option value="">--Select lga--</option>
                            {lgas.map((lga) => (
                              <option
                                key={lga.value}
                                value={`${lga.value}#${lga.text}`}
                              >
                                {lga.text}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>
                            State of residence{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="stateOfResidence"
                            name="stateOfResidence"
                            required
                            value={data.stateOfResidence}
                            onChange={handleChange}
                          >
                            <option value="">
                              --Select state of residence--
                            </option>
                            {states.map((state) => (
                              <option
                                key={state.value}
                                value={`${state.value}#${state.text}`}
                              >
                                {state.text}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Country of residence{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="countryOfResidence"
                            name="countryOfResidence"
                            required
                            value={data.countryOfResidence}
                            onChange={handleChange}
                          >
                            <option value="">--Select country--</option>
                            <option value={nationalityCode}>Nigeria</option>
                          </select>
                        </div>
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            City <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="city"
                            name="city"
                            required
                            value={data.city}
                            onChange={handleChange}
                          >
                            <option value="">--Select city--</option>
                            {lgas.map((lga) => (
                              <option
                                key={lga.value}
                                value={`${lga.value}#${lga.text}`}
                              >
                                {lga.text}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Province <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="province"
                            name="province"
                            required
                            value={data.province}
                            onChange={handleChange}
                          >
                            <option value="">--Select province--</option>
                            {provinces.map((prov) => {
                              return (
                                <option
                                  key={prov.value}
                                  value={`${prov.value}#${prov.text}`}
                                >
                                  {prov.text}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- </div> --> */}
                </div>

                {/* <!-- ACCOUNT SERVICED REQUIRED --> */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-credit-card m-r-5"></i> Account Services
                    Required
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where preffered account services are
                        selected.
                      </div>
                    </div>

                    <div className="section-forms col-lg-9">
                      {/* <!-- <div className="col-lg-12"> --> */}
                      <div className="row">
                        <div className="form-group col-lg-12 col-md-6 col-sm-12"></div>

                        <div className="form-group col-lg-12 col-md-6 col-sm-12 m-b-10">
                          {checkAgeRange === "13-17" ? (
                            <div className="custom-control custom-checkbox col-lg-6 col-md-12 col-sm-12">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="ib4"
                                name="debitCard"
                                value="debitCard"
                                checked={data.accountServices.debitCard}
                                onChange={handleChange}
                                //   required
                                data-parsley-errors-container="#error-checkbox"
                              />

                              <label
                                className="custom-control-label m-b-10"
                                htmlFor="ib4"
                              >
                                {/* <div className="font-weight-500"> */}
                                Debit Card (Age 10 - 18yrs)
                                {/* </div> */}
                              </label>
                            </div>
                          ) : (
                            ""
                          )}

                          {/* <p id="error-checkbox"></p> */}
                        </div>
                      </div>

                      <div className="row">
                        <div className="form-group col-lg-6 col-md-6 col-sm-12 font-weight-500">
                          <label>Introducer Code</label>
                          <input
                            type="text"
                            name="introducerCode"
                            className="form-control"
                            value={data.introducerCode}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-6 col-md-6 col-sm-12 font-weight-500">
                          <label>
                            Select Product Type{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="productType"
                            id="productType"
                            required
                            value={data.productType}
                            onChange={handleChange}
                          >
                            <option value="">Select product type</option>

                            {products.map((product) => (
                              <option
                                key={product.id}
                                value={product.productTypeCode}
                              >
                                {product.accountType}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group col-lg-6 col-md-6 col-sm-12 font-weight-500">
                          <label>
                            Select Bank Branch{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="braCode"
                            id="braCode"
                            required
                            value={data.braCode}
                            onChange={handleChange}
                            // onChange={(e)=>setBranch(e.target.value)}
                          >
                            <option value="">Select branch</option>
                            {data.productType === "51"
                              ? branches
                                  .filter((branch) => branch.value === "209")
                                  .map((branch) => (
                                    <option
                                      key={branch.value}
                                      value={`${branch.value}#${branch.text}`}
                                    >
                                      {branch.text}
                                    </option>
                                  ))
                              : branches
                                  .filter((branch) => branch.value !== "209")
                                  .map((branch) => (
                                    <option
                                      key={branch.value}
                                      value={`${branch.value}#${branch.text}`}
                                    >
                                      {branch.text}
                                    </option>
                                  ))}
                          </select>
                        </div>
                      </div>

                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                  {/* <!-- </div> --> */}
                </div>

                {/* <!-- UPLOAD DOCUMENTS --> */}
                {/* {!isEditMode && ( */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-files-o m-r-5"></i> Upload Documents
                  </div>

                  {/* <!-- <div className="row"> --> */}

                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where Documents and Means of
                        Identification of the child are uploaded.
                      </div>
                    </div>

                    <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                      {/* <!-- <div className="col-lg-12"> --> */}
                      <div className="row">
                        <div className="form-group col-lg-12 col-md-12 col-sm-12 font-weight-500 m-b-30">
                          To confirm your identity, please upload all documents
                          in the drop down menu.
                        </div>

                        <div className="row col-lg-12 col-md-12 col-sm-12">
                          <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                            <label>
                              SELECT A DOCUMENT TO UPLOAD{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control dropdown"
                              id="document-type"
                              name="document-type"
                              onChange={(e) =>
                                setSelectedOption(e.target.value)
                              }
                            >
                              <option value="">--select ID type--</option>
                              {docs.map((doc) => (
                                <option
                                  key={doc.id}
                                  value={`${doc.id}#${doc.title}`}
                                >
                                  {doc.title}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                            <label>
                              UPLOAD A DOCUMENT{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <input
                              type="file"
                              id="document-file"
                              name="document"
                              accept=".doc,.docx,.pdf..jpeg,.png,.PNG,.jpg"
                              onChange={(e) =>
                                setSelectedFile(e.target.files[0])
                              }
                            />
                            <p id="error-message" style={{ color: "red" }}>
                              {errorMessage}
                            </p>
                          </div>

                          <div className="form-group col-lg-4 col-md-12 col-sm-12 font-weight-500">
                            <label> &nbsp; </label>
                            <div className="form-group col-lg-6 col-md-12 col-sm-12">
                              <button
                                onClick={handleAddDocument}
                                className="btn btn-block btn-suntrust"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                        {data.documents.length > 0 && (
                          <div className="form-group col-lg-12 col-md-12 col-sm-12 font-weight-500">
                            <div className="table-responsive border">
                              <table className="table table-hover mb-0 c_list">
                                <thead
                                  className="font-weight-500"
                                  style={{ backgroundColor: "#eee" }}
                                >
                                  <tr>
                                    <th>S/N</th>
                                    <th>Title</th>
                                    <th>Attachment</th>
                                    <th className="d-flex align-items-center justify-content-center">
                                      Action
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {data.documents.map((document, index) => {
                                    index = index === 0 ? 1 : index + 1;
                                    return (
                                      <tr key={index}>
                                        <td>{index}</td>
                                        <td>
                                          {document.documentType.split("#")[1]}
                                        </td>
                                        <td>{document.name}</td>
                                        <td className="d-flex align-items-center justify-content-center">
                                          <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm m-r-10"
                                            onClick={() =>
                                              handleViewDocument(document.file)
                                            }
                                          >
                                            <i className="fa fa-eye"></i>
                                          </button>

                                          <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => deleteDoc(index)}
                                          >
                                            <i className="fa fa-trash-o"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>

                  {/* <!-- </div> --> */}
                </div>
                {/* )}  */}

                <div className="form-group col-lg-12 col-md-12 col-sm-12 m-b-50">
                  <div className="d-flex align-items-center justify-content-center m-t-20">
                    <div className="col-lg-3 col-md-6 col-sm-12 m-b-10">
                      <button
                        className="btn btn-block btn-suntrust font-weight-500"
                        type="submit"
                      >
                        {/* {isEditMode ? (isLoading ? <Loader /> : "Update") : (isLoading ? <Loader /> : "Add Child")} */}
                        {isLoading ? <Loader /> : "Add Child"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>

              {/* <!-- CHILDREN TABLE --> */}
              {!isLoading && childrenInformations.length > 0 ? (
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-users m-r-5"></i>{" "}
                    {`${
                      childrenInformations.length > 1
                        ? "Children's Table"
                        : "Child's Table"
                    }`}
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section displays basic details of added
                        child(ren)
                      </div>
                    </div>

                    <div className="section-forms p-10 col-lg-9">
                      {/* <!-- <div className="col-lg-12"> --> */}
                      <div className="row">
                        <div className="form-group col-lg-12 col-md-12 col-sm-12">
                          <div className="table-responsive border">
                            <table className="table table-hover mb-0 c_list">
                              <thead
                                className="font-weight-500"
                                style={{ backgroundColor: "#eee" }}
                              >
                                <tr>
                                  <th>S/N</th>
                                  <th>Firstname</th>
                                  <th>Lastname</th>
                                  <th>Date of Birth</th>
                                  <th>Gender</th>
                                  <th className="d-flex align-items-center justify-content-center">
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {childrenInformations.map((data, index) => {
                                  index = index === 0 ? 1 : index + 1;
                                  return (
                                    <tr key={index}>
                                      <td>{index}</td>
                                      <td>{data.firstName}</td>
                                      <td>{data.surName}</td>
                                      <td>{data.dateOfBirth}</td>
                                      <td>{data.gender.split("#")[1]}</td>
                                      <td className="d-flex align-items-center justify-content-center">
                                        {/* <button
                                        className="btn btn-outline-danger btn-sm m-b-5 m-r-10"
                                        title="Edit"
                                        onClick={() => handleEdit(data)}
                                      >
                                        <i className="fa fa-edit"></i>
                                      </button> */}
                                        <button
                                          type="button"
                                          className="btn btn-outline-danger btn-sm m-b-5"
                                          title="Delete"
                                          onClick={() => deleteCheck(index)}
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                  {/* <!-- </div> --> */}
                </div>
              ) : (
                ""
              )}
            </div>
            {!isLoading && childrenInformations.length > 0 ? (
              <div className="form-group col-lg-12 col-md-12 col-sm-12 m-b-20">
                <div className="d-flex align-items-center justify-content-center m-t-20">
                  <div className="user_acct_details col-lg-3 col-md-6 col-sm-12 m-b-10">
                    <button
                      className="btn btn-block btn-suntrust font-weight-500"
                      onClick={handlePrevClick}
                    >
                      Previous Page
                    </button>
                  </div>

                  <div className="user_acct_details col-lg-3 col-md-6 col-sm-12 m-b-10">
                    <button
                      className="btn btn-block btn-suntrust font-weight-500"
                      onClick={handleNextClick}
                    >
                      Next Page
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChildInfo;
